export default __webpack_public_path__ + "media/images/tenant/timeline/number_4-f1cf292e8d3555cb0800a101fb78162c.svg";